import { render, staticRenderFns } from "./RetailerGroupSwitcher.vue?vue&type=template&id=736b6832&scoped=true&"
import script from "./RetailerGroupSwitcher.vue?vue&type=script&lang=ts&"
export * from "./RetailerGroupSwitcher.vue?vue&type=script&lang=ts&"
import style0 from "./RetailerGroupSwitcher.vue?vue&type=style&index=0&id=736b6832&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736b6832",
  null
  
)

export default component.exports